import initialTemplateState from "./initialTemplateState";
import initialUserState from "./initialUserState";

//initial state for the reducer
const initialState = {
	templateState: initialTemplateState,
	userState: initialUserState,
};

export default initialState;

